export default {
      id: "telegram-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#telegram",
      toString: function () {
        return this.url;
      }
    }